import Quill from 'quill';

import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
})
export class TextEditorComponent implements OnInit {
  @Input() value;
  @Input() updateControl: UntypedFormControl;
  @Input() placeholder: string = '';

  @Input() formats = [
    'background',
    'bold',
    'color',
    'font',
    'italic',
    'link',
    'size',
    'strike',
    'script',
    'underline',
    'blockquote',
    'header',
    'indent',
    'list',
    'align',
    'direction',
    'image',
    'video',
  ];

  @Input() modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      ['link'],
      ['clean'],
    ],
  };

  constructor() {}

  ngOnInit(): void {}

  editorCreated(quill: Quill): void {
    quill.clipboard.addMatcher('IMG', (node, delta) => {
      const Delta = Quill.import('delta');
      return new Delta().insert('');
    });
    quill.clipboard.addMatcher('PICTURE', (node, delta) => {
      const Delta = Quill.import('delta');
      return new Delta().insert('');
    });
    quill.clipboard.addMatcher('VIDEO', (node, delta) => {
      const Delta = Quill.import('delta');
      return new Delta().insert('');
    });
  }
}
